import React from "react"
import "./index.css"
import Container from "react-bootstrap/Container"
import Helmet from "react-helmet"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import logo from "../../assets/20200404_062147.gif"
import LoginButton from "../../components/loginbutton"
import Nav from "../../components/nav"

const LoginView = props => (
  <div className={"login"}>
    <Helmet>Login | {process.env.REACT_APP_NAME}</Helmet>
    <Nav nopfp />
    <div className={"wrapper"}>
      <Container>
        <Row>
          <Col>
            <div className={"logo-s"}>
              <img src={logo} alt={process.env.REACT_APP_NAME} />
            </div>
            <div className={"header"}>
              <p>Login to {process.env.REACT_APP_NAME}</p>
            </div>
            <div className={"button-cunt"}>
              <a
                href={`${
                  process.env.REACT_APP_DISCORD_AUTHORIZE_URL
                }?client_id=${
                  process.env.REACT_APP_CLIENT_ID
                }&redirect_uri=${encodeURIComponent(
                  window.location.href.split(/[?#]/)[0]
                )}&response_type=code&scope=identify%20guilds`}
              >
                <LoginButton />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  </div>
)

export default LoginView



// WEBPACK FOOTER //
// ./src/routes/login/LoginView.js